var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.25V5.25C8.5 3.59315 9.84315 2.25 11.5 2.25H13.5C15.1569 2.25 16.5 3.59315 16.5 5.25V6.25M2.5 10.5975C2.5 10.5975 5.61804 12.6744 10.4777 13.1609M22.5 10.5975C22.5 10.5975 19.382 12.6744 14.5223 13.1609M6.5 22.25H18.5C20.7091 22.25 22.5 20.4591 22.5 18.25V10.25C22.5 8.04086 20.7091 6.25 18.5 6.25H6.5C4.29086 6.25 2.5 8.04086 2.5 10.25V18.25C2.5 20.4591 4.29086 22.25 6.5 22.25Z",
    stroke: "#666564",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.4102V13.4102C14.5 13.4202 14.5 13.4202 14.5 13.4302C14.5 14.5202 14.49 15.4102 12.5 15.4102C10.52 15.4102 10.5 14.5302 10.5 13.4402V12.4102C10.5 11.4102 10.5 11.4102 11.5 11.4102H13.5C14.5 11.4102 14.5 11.4102 14.5 12.4102Z",
    stroke: "#666564",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.cec75cc827091213dd84ee7a19c64aa9.svg";
export { ForwardRef as ReactComponent };